import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { getDataProjects } from "../helpers/fetchDataProject";

const Projects = ({ handleClose, handleShow }) => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    const initFetch = async () => {
      handleShow();
      try {
        const dataProjects = await getDataProjects();

        setContent(dataProjects);
        setTimeout(() => {
          handleClose();
        },500)
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    window.scrollTo(0, 0);

    if (!content) {
      initFetch();
    }
  }, [content, handleClose, handleShow]);

  return (
    <>
      <div
        style={{
          backgroundImage:
            "url('https://res.cloudinary.com/dr0lbokc5/image/upload/v1702146276/Group_37877_glv3ug.png')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Container className="d-flex flex-column justify-content-center align-items-center px-4">
          <div className="cust-welcoming col-10 m-0">
            <h1
              style={{
                fontSize: "40px",
                fontWeight: "bold",
              }}
            >
              Our Projects
            </h1>
          </div>
        </Container>
      </div>
      { content && <Container className="d-flex flex-column justify-content-center align-items-center px-4">
        <div className="d-flex flex-column col-10 gap-5 pb-5">
          {content.map((item) => {
            const { project_id, title, project_url, description, image_url } = item;

            return (
              <div key={project_id} className="d-flex gap-4">
                {project_id % 2 === 0 ? (
                  <>
                    <div className="d-flex flex-column justify-content-center align-items-start">
                      <h3
                        style={{
                          color: "#757575",
                          fontWeight: "bold",
                          fontSize: "32px",
                        }}
                      >
                        {title}
                      </h3>
                      <p
                        style={{
                          color: "#757575",
                          fontWeight: "normal",
                          fontSize: "18px",
                        }}
                      >
                        {description}
                      </p>
                      <Link
                        to={`/project/${project_id}`}
                        style={{
                          padding: "16px 24px",
                          borderRadius: "8px",
                          backgroundColor: "transparent",
                          color: "#E45B0D",
                          border: "1px solid #E45B0D",
                          fontSize: "16px",
                          fontWeight: "bold",
                          textDecoration: "none",
                        }}
                      >
                        Read More
                      </Link>
                    </div>
                    <img
                      src={image_url[0].image_url}
                      style={{
                        height: "480px",
                      }}
                      alt="imageproject"
                    />
                  </>
                ) : (
                  <>
                    <img
                      src={image_url[0].image_url}
                      style={{
                        height: "480px",
                      }}
                      alt="imageproject"
                    />
                    <div className="d-flex flex-column justify-content-center align-items-start">
                      <h3
                        style={{
                          color: "#757575",
                          fontWeight: "bold",
                          fontSize: "32px",
                        }}
                      >
                        {title}
                      </h3>
                      <p
                        style={{
                          color: "#757575",
                          fontWeight: "normal",
                          fontSize: "18px",
                        }}
                      >
                        {description}
                      </p>
                      <Link
                        to={`/project/${project_id}`}
                        style={{
                          padding: "16px 24px",
                          borderRadius: "8px",
                          backgroundColor: "transparent",
                          color: "#E45B0D",
                          border: "1px solid #E45B0D",
                          fontSize: "16px",
                          fontWeight: "bold",
                          textDecoration: "none",
                        }}
                      >
                        Read More
                      </Link>
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </Container>}
    </>
  );
};

export default Projects;
